// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AppSettingsRouteImport } from './routes/app/settings'
import { Route as AppSeriesRouteImport } from './routes/app/series'
import { Route as AppScheduleRouteImport } from './routes/app/schedule'
import { Route as AppReportingRouteImport } from './routes/app/reporting'
import { Route as AppProfileRouteImport } from './routes/app/profile'
import { Route as AppMyClassesRouteImport } from './routes/app/my-classes'
import { Route as AppMembersRouteImport } from './routes/app/members'
import { Route as AppDashboardRouteImport } from './routes/app/dashboard'
import { Route as AppCurriculumRouteImport } from './routes/app/curriculum'
import { Route as AppClassesRouteImport } from './routes/app/classes'
import { Route as AppBillingRouteImport } from './routes/app/billing'
import { Route as AppSeriesIndexRouteImport } from './routes/app/series/index'
import { Route as AppSeriesCreateRouteImport } from './routes/app/series/create'
import { Route as AppSeriesSeriesIdRouteImport } from './routes/app/series/$seriesId'
import { Route as AppMembersMemberIdRouteImport } from './routes/app/members/$memberId'
import { Route as AppCurriculumIndexRouteImport } from './routes/app/curriculum/index'
import { Route as AppCurriculumCreateRouteImport } from './routes/app/curriculum/create'
import { Route as AppCurriculumCurriculumIdRouteImport } from './routes/app/curriculum/$curriculumId'
import { Route as AppClassesIndexRouteImport } from './routes/app/classes/index'
import { Route as AppClassesCreateRouteImport } from './routes/app/classes/create'
import { Route as AppClassesClassIdRouteImport } from './routes/app/classes/$classId'
import { Route as AppSeriesSeriesIdEditRouteImport } from './routes/app/series/$seriesId/edit'
import { Route as AppCurriculumCurriculumIdIndexRouteImport } from './routes/app/curriculum/$curriculumId/index'
import { Route as AppCurriculumCurriculumIdEditRouteImport } from './routes/app/curriculum/$curriculumId/edit'

const AppRoute = AppRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthLoginRoute = AuthLoginRouteImport.update({
            id: '/auth/login',path: '/auth/login',getParentRoute: () => rootRouteImport
          })
const AuthCallbackRoute = AuthCallbackRouteImport.update({
            id: '/auth/callback',path: '/auth/callback',getParentRoute: () => rootRouteImport
          })
const AppSettingsRoute = AppSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AppRoute
          })
const AppSeriesRoute = AppSeriesRouteImport.update({
            id: '/series',path: '/series',getParentRoute: () => AppRoute
          })
const AppScheduleRoute = AppScheduleRouteImport.update({
            id: '/schedule',path: '/schedule',getParentRoute: () => AppRoute
          })
const AppReportingRoute = AppReportingRouteImport.update({
            id: '/reporting',path: '/reporting',getParentRoute: () => AppRoute
          })
const AppProfileRoute = AppProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AppRoute
          })
const AppMyClassesRoute = AppMyClassesRouteImport.update({
            id: '/my-classes',path: '/my-classes',getParentRoute: () => AppRoute
          })
const AppMembersRoute = AppMembersRouteImport.update({
            id: '/members',path: '/members',getParentRoute: () => AppRoute
          })
const AppDashboardRoute = AppDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AppRoute
          })
const AppCurriculumRoute = AppCurriculumRouteImport.update({
            id: '/curriculum',path: '/curriculum',getParentRoute: () => AppRoute
          })
const AppClassesRoute = AppClassesRouteImport.update({
            id: '/classes',path: '/classes',getParentRoute: () => AppRoute
          })
const AppBillingRoute = AppBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => AppRoute
          })
const AppSeriesIndexRoute = AppSeriesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppSeriesRoute
          })
const AppSeriesCreateRoute = AppSeriesCreateRouteImport.update({
            id: '/create',path: '/create',getParentRoute: () => AppSeriesRoute
          })
const AppSeriesSeriesIdRoute = AppSeriesSeriesIdRouteImport.update({
            id: '/$seriesId',path: '/$seriesId',getParentRoute: () => AppSeriesRoute
          })
const AppMembersMemberIdRoute = AppMembersMemberIdRouteImport.update({
            id: '/$memberId',path: '/$memberId',getParentRoute: () => AppMembersRoute
          })
const AppCurriculumIndexRoute = AppCurriculumIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppCurriculumRoute
          })
const AppCurriculumCreateRoute = AppCurriculumCreateRouteImport.update({
            id: '/create',path: '/create',getParentRoute: () => AppCurriculumRoute
          })
const AppCurriculumCurriculumIdRoute = AppCurriculumCurriculumIdRouteImport.update({
            id: '/$curriculumId',path: '/$curriculumId',getParentRoute: () => AppCurriculumRoute
          })
const AppClassesIndexRoute = AppClassesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppClassesRoute
          })
const AppClassesCreateRoute = AppClassesCreateRouteImport.update({
            id: '/create',path: '/create',getParentRoute: () => AppClassesRoute
          })
const AppClassesClassIdRoute = AppClassesClassIdRouteImport.update({
            id: '/$classId',path: '/$classId',getParentRoute: () => AppClassesRoute
          })
const AppSeriesSeriesIdEditRoute = AppSeriesSeriesIdEditRouteImport.update({
            id: '/edit',path: '/edit',getParentRoute: () => AppSeriesSeriesIdRoute
          })
const AppCurriculumCurriculumIdIndexRoute = AppCurriculumCurriculumIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppCurriculumCurriculumIdRoute
          })
const AppCurriculumCurriculumIdEditRoute = AppCurriculumCurriculumIdEditRouteImport.update({
            id: '/edit',path: '/edit',getParentRoute: () => AppCurriculumCurriculumIdRoute
          })





const AppClassesRouteChildren = {
  AppClassesClassIdRoute: AppClassesClassIdRoute,AppClassesCreateRoute: AppClassesCreateRoute,AppClassesIndexRoute: AppClassesIndexRoute
}

const AppClassesRouteWithChildren = AppClassesRoute._addFileChildren(AppClassesRouteChildren)




const AppCurriculumCurriculumIdRouteChildren = {
  AppCurriculumCurriculumIdEditRoute: AppCurriculumCurriculumIdEditRoute,AppCurriculumCurriculumIdIndexRoute: AppCurriculumCurriculumIdIndexRoute
}

const AppCurriculumCurriculumIdRouteWithChildren = AppCurriculumCurriculumIdRoute._addFileChildren(AppCurriculumCurriculumIdRouteChildren)



const AppCurriculumRouteChildren = {
  AppCurriculumCurriculumIdRoute: AppCurriculumCurriculumIdRouteWithChildren,AppCurriculumCreateRoute: AppCurriculumCreateRoute,AppCurriculumIndexRoute: AppCurriculumIndexRoute
}

const AppCurriculumRouteWithChildren = AppCurriculumRoute._addFileChildren(AppCurriculumRouteChildren)




const AppMembersRouteChildren = {
  AppMembersMemberIdRoute: AppMembersMemberIdRoute
}

const AppMembersRouteWithChildren = AppMembersRoute._addFileChildren(AppMembersRouteChildren)




const AppSeriesSeriesIdRouteChildren = {
  AppSeriesSeriesIdEditRoute: AppSeriesSeriesIdEditRoute
}

const AppSeriesSeriesIdRouteWithChildren = AppSeriesSeriesIdRoute._addFileChildren(AppSeriesSeriesIdRouteChildren)



const AppSeriesRouteChildren = {
  AppSeriesSeriesIdRoute: AppSeriesSeriesIdRouteWithChildren,AppSeriesCreateRoute: AppSeriesCreateRoute,AppSeriesIndexRoute: AppSeriesIndexRoute
}

const AppSeriesRouteWithChildren = AppSeriesRoute._addFileChildren(AppSeriesRouteChildren)



const AppRouteChildren = {
  AppBillingRoute: AppBillingRoute,AppClassesRoute: AppClassesRouteWithChildren,AppCurriculumRoute: AppCurriculumRouteWithChildren,AppDashboardRoute: AppDashboardRoute,AppMembersRoute: AppMembersRouteWithChildren,AppMyClassesRoute: AppMyClassesRoute,AppProfileRoute: AppProfileRoute,AppReportingRoute: AppReportingRoute,AppScheduleRoute: AppScheduleRoute,AppSeriesRoute: AppSeriesRouteWithChildren,AppSettingsRoute: AppSettingsRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AppRoute: AppRouteWithChildren,AuthCallbackRoute: AuthCallbackRoute,AuthLoginRoute: AuthLoginRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)